export default __webpack_public_path__ + "static/media/Search-Bluetooth.7ded566b.png";